module.exports = __webpack_public_path__ + "img/arrow_drop_up.cab1aff0.svg";